import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AssetGroupDto } from '@assetaccountant/api/models/asset-group.dto';
import { CreateAssetGroupCommand } from '@assetaccountant/api/models/asset-groups/create-asset-group.command';
import { RegisterV2Api } from '@assetaccountant/api/services/register-v2.api';
import { TrackingService } from '@assetaccountant/core/services/tracking.service';
import { emptyValue } from '@assetaccountant/core/utils/typed-forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-new-assetgroup-panel',
  templateUrl: './new-assetgroup-panel.component.html',
  styleUrls: ['./new-assetgroup-panel.component.scss'],
  standalone: false,
})
export class NewAssetgroupPanelComponent {
  @Output() cancel = new EventEmitter<null>();
  @Output() groupCreated = new EventEmitter<AssetGroupDto>();

  form = this.formBuilder.group({
    name: [emptyValue<string>(), [Validators.required, Validators.maxLength(50)]],
    description: [emptyValue<string>(), Validators.maxLength(500)],
    parentGroup: [emptyValue<string>()],
  });

  constructor(
    private formBuilder: FormBuilder,
    private registerApi: RegisterV2Api,
    private trackingService: TrackingService,
    private toastr: ToastrService,
  ) {}

  onCancel() {
    this.cancel.emit();
  }

  save() {
    const assetGroup = { ...this.form.value };

    this.registerApi.createAssetGroup({ assetGroup } as CreateAssetGroupCommand).subscribe(
      response => {
        this.toastr.success(`Asset Group '${assetGroup.name}' has been created.`);
        this.trackingService.trackEvent('Create asset group - from new asset');
        this.groupCreated.emit(response.assetGroup);
      },
      error => {
        this.toastr.error('Failed to create Asset Group.');
      },
    );
  }
}
